"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const intl_1 = require("@kyruus/intl");
/**
 * Internationalized messages for this widget
 * These get passed through `React-Intl`
 * And should follow a format of:
 * Roses are {color_1} and violets are {color_2}
 */
exports.default = (0, intl_1.defineMessages)({
    // button.*
    // ========
    loadMoreBtnText: {
        id: 'button.load_more',
        description: 'Text for load more appointments button',
        defaultMessage: 'View More Appointment Times'
    },
    showMap: {
        id: 'button.map.show',
        description: 'label for a button to show the map',
        defaultMessage: 'Show Map'
    },
    hideMap: {
        id: 'button.map.hide',
        description: 'label for a button to hide the map',
        defaultMessage: 'Hide Map'
    },
    next: {
        id: 'button.next',
        description: 'label for the Next button that moves the user from appt info to appt time',
        defaultMessage: 'Next'
    },
    nextloader: {
        id: 'button.next.loader',
        description: 'Message to display while waiting on the next button to render (for example, due to an async call)',
        defaultMessage: 'Checking on that...'
    },
    // link.*
    // ========
    goNow: {
        id: 'link.go_now',
        description: 'Text for a manual redirect link',
        defaultMessage: 'Go now.'
    },
    clickHere: {
        id: 'link.click_here',
        description: 'Text for a link',
        defaultMessage: 'Click here'
    },
    // info.*
    // ========
    noFilteredResultsClearBtn: {
        id: 'info.no_filtered_results_clear_btn',
        description: 'Text for clear filters button',
        defaultMessage: 'Clear Filters'
    },
    noFilteredResultsLoadMoreBtn: {
        id: 'info.no_filtered_results_load_more_btn',
        description: 'Text for load more button',
        defaultMessage: 'Search Later Dates'
    },
    noFilteredResults: {
        id: 'info.no_filtered_results',
        description: 'Message used to indicate that we did not find any results with the current filters applied',
        defaultMessage: 'There are no appointments that meet your filtering criteria between {jumpedToDate} and {date}.'
    },
    noFilteredResultsNoMoreResults: {
        id: 'info.no_filtered_results_no_more_results',
        description: 'Message used to indicate that we did not find any results with the current filters applied and there are no more results available',
        defaultMessage: 'There are no appointments that meet your filtering criteria between {jumpedToDate} and {date}. There are no more appointments available from {date}.'
    },
    noJumpToDateResults: {
        id: 'info.no_jump_to_date_results',
        description: 'Message used to indicate that we did not find any results at the date jumped to',
        defaultMessage: 'There are no appointments available from {date}.'
    },
    bookingRedirect: {
        id: 'info.booking_redirect',
        description: 'Message used to indicate that we are redirecting the user to select a new appointment',
        defaultMessage: 'We are redirecting you to the {stepName} step to select a new appointment.'
    },
    showingAppointmentsUpToDate: {
        id: 'info.showing_appointments_up_to_date',
        description: 'Message used to indicate how far out (what date) the currently shown appointment slots have been queried up to',
        defaultMessage: 'Showing available appointments up to {date_queried_to}'
    },
    bookedSlotDetails: {
        id: 'info.booked_slot_date_and_time',
        description: 'Message used to indicate the details of the booked appointment slot',
        defaultMessage: '{slot_date} at {slot_time} '
    },
    bookedSlotDuration: {
        id: 'info.booked_slot_duration',
        description: 'Message used to indicate the duration of the booked appointment slot',
        defaultMessage: '({slot_duration} min)'
    },
    regulatedSpacesBanner: {
        id: 'info.regulated_spaces_banner',
        description: 'Message used to indicate that a given location on the ApptTime step is a regulated space (additional fees)',
        defaultMessage: 'An additional fee may apply when booking at this location.'
    },
    regulatedSpacesBannerWithLink: {
        id: 'info.regulated_spaces_banner_with_link',
        description: 'Message used to indicate that a given location on the ApptTime step is a regulated space (additional fees)',
        defaultMessage: 'An additional fee may apply when booking at this location. {regulated_spaces_link} for more information.'
    },
    regulatedSpacesBannerLinkTitle: {
        id: 'regulated_spaces_link.title_attribute',
        description: 'Title for the regulated spaces link',
        defaultMessage: 'Information about additional fees at {location_name}'
    },
    // add_to_calendar.*
    // =================
    addToCalendar: {
        id: 'add_to_calendar.button_text',
        description: 'Text for the button that lets users add their booked appointments to their calendars',
        defaultMessage: 'Add to Calendar'
    },
    // location.*
    // ===========
    notBookableLocation: {
        id: 'location.not.bookable',
        description: 'message for a location that is not bookable - NOTE: phone is not included here to enable dfferent styling',
        defaultMessage: 'Online scheduling not available at this location. Call '
    },
    allLocations: {
        id: 'location.all_locations',
        description: 'display value for locations when all the locations are selected',
        defaultMessage: 'All Locations'
    },
    notBookableLocationMobile: {
        id: 'location.call_to_phone',
        description: 'message for a location that is not bookable for mobile view',
        defaultMessage: 'Call {phone_number_link} to book'
    },
    // scheduling.*
    // =============
    schedulingHelp: {
        id: 'scheduling.help',
        description: 'message used for contact help when scheduling appointment',
        defaultMessage: "Need help scheduling an appointment? We're here to help. Call us at {phone_number_link}"
    },
    // contact.*
    // =========
    contactPhone: {
        id: 'contact.phone',
        description: 'Message to book appointment for location with phone number',
        defaultMessage: 'Please call {phone_number_link} to book an appointment.'
    },
    // appointment_booked.*
    // ====================
    apptSummaryMessage: {
        id: 'appointment_booked.complete.message',
        description: 'The message below the page heading on the appointment summary page',
        defaultMessage: "{display_name}'s office might reach out prior to your appointment to confirm details."
    },
    apptArrivalTime: {
        id: 'appointment_booked.arrival_time',
        description: 'The message for arrival time details based on booked appointment slot.',
        defaultMessage: 'Please arrive by {arrivalTime}.'
    },
    preVisitTitle: {
        id: 'appointment_booked.pre_visit_title',
        description: 'The title for the pre-visit check-in section',
        defaultMessage: 'PreVisit Check-in'
    },
    preVisitDescription: {
        id: 'appointment_booked.pre_visit_description',
        description: 'The description for the pre-visit check-in section',
        defaultMessage: 'Get a head start! Save time on the PreVisit Check-in process for your scheduled appointment.'
    },
    preVisitButton: {
        id: 'appointment_booked.pre_visit_button',
        description: 'The button for the pre-visit check-in section',
        defaultMessage: 'Start Early Check-in'
    },
    // no_future_appointments*
    // =====================
    noFutureAppointmentsWithPhone: {
        id: 'no_future_appointments_with_phone',
        description: 'No future appointments text with contact phone',
        defaultMessage: 'Please call {phone_number_link} for additional appointments'
    },
    noFutureAppointments: {
        id: 'no_future_appointments',
        description: 'No future appointments text without contact phone',
        defaultMessage: 'No future appointments'
    },
    // appointment_panel.*
    // ===================
    newPatient: {
        id: 'appointment_panel.new_patient_type',
        description: 'A message that reads: New Patient',
        defaultMessage: 'New Patient'
    },
    establishedPatient: {
        id: 'appointment_panel.existing_patient_type',
        description: 'A message that reads: Established Patient',
        defaultMessage: 'Established Patient'
    },
    patientName: {
        id: 'appointment_panel.patient_name',
        description: 'A label that renders: Patient name',
        defaultMessage: 'Patient name'
    },
    appointmentDetails: {
        id: 'appointment_panel.appointment_details_header',
        description: 'The heading above the appointment details section of the review and book page',
        defaultMessage: 'Appointment Details'
    },
    patientType: {
        id: 'appointment_panel.patient_label',
        description: 'A label that renders: Patient type',
        defaultMessage: 'Patient type'
    },
    apptTimeFilterShowFilters: {
        id: 'appointment_panel.show_filters',
        description: 'Text for the button to show additional filters',
        defaultMessage: 'Show additional filters'
    },
    apptTimeFilterHideFilters: {
        id: 'appointment_panel.hide_filters',
        description: 'Text for the button to hide additional filters',
        defaultMessage: 'Hide additional filters'
    },
    // error.*
    // ========
    bookApptError: {
        id: 'error.book_appointment_error',
        description: 'The error message that displays when there is an error booking an appointment',
        defaultMessage: 'We are having trouble booking your appointment. Please try again or call {phone_number_link}.'
    },
    jumpToDateInvalidDateError: {
        id: 'error.jumpToDate.invalid',
        description: 'Error message when an invalid date is entered into the jump to date input',
        defaultMessage: 'Please pick a valid date.'
    },
    // @deprecated in favor of `bookApptError`
    // errorbasegenericmessage: {
    //   id: 'error.base_generic_message',
    //   description: 'Base Generic Message',
    //   defaultMessage:
    //     "We're having trouble booking your appointment. Please try again later"
    // },
    bookApptErrorNoPhone: {
        id: 'error.book_appointment_error_no_phone',
        description: 'The error message that displays when there is an error booking an appointment and there is no phone number to call',
        defaultMessage: "We are having trouble booking your appointment. Please try again or call your provider's office."
    },
    noapptpurposes: {
        id: 'error.no_appointment_purposes',
        description: 'Error for when the provider does not accept online booking',
        defaultMessage: 'Sorry! {provider_name} does not accept {patient_status} patients via online booking.'
    },
    bookApptUnavailableToSchedule: {
        id: 'error.unavailable_to_schedule',
        description: 'Error for when a choice the user made indicates they cannot schedule their appointment online',
        defaultMessage: 'You may not be eligible for scheduling your appointment online.'
    },
    contactoffice: {
        id: 'error.contact_office',
        description: 'Tell user to contact office directly to book appt',
        defaultMessage: 'Please contact the office directly at {phone_number_link} to book an appointment.'
    },
    phonenumberorcall: {
        id: 'error.phone_number_or_call',
        description: 'Phone number or call message',
        defaultMessage: ' or call {phone_number_link}.'
    },
    apptUnavailableError: {
        id: 'error.appointment_unavailable',
        description: 'Banner error message for when an appointment is unavailable',
        defaultMessage: 'Appointment Unavailable'
    },
    waitlistOptInSuccess: {
        id: 'banner.waitlist_opt_in_success',
        description: 'Success message when a user has successfully opted in to the waitlist',
        defaultMessage: 'You have been successfully added to the waitlist. We will notify you if an appointment becomes available.'
    },
    deepLinkingUnavailableSlotError: {
        id: 'error.deep_linking_unavailable_slot',
        description: 'Banner error message when deep linked slot is no longer available',
        defaultMessage: 'Unfortunately, the selected appointment time for {appt_time} is no longer available. Please select another appointment time below.'
    },
    mainPatientDemographicLoadError: {
        id: 'error.main_patient_demographic_load_error',
        description: "Banner error message when the original demographics call fails and we can't show the proxy booking select controls",
        defaultMessage: "We had trouble loading your saved patient demographics. To continue, fill in the patient's demographics below."
    },
    subPatientDemographicLoadError: {
        id: 'error.sub_patient_demographic_load_error',
        description: "Banner error message when a demographics call for an associated patient fails. Should indicate that retry is possible via reselecting the patient's name.",
        defaultMessage: "We had trouble loading the patient's info. Try selecting the patient's name again or fill in their info below"
    },
    relatedPatientDemographicLoadError: {
        id: 'error.related_patient_demographic_load_error',
        description: "Banner error message when the main demographics call succeeds but the backend 'related patient' call fails. Should indicate that user may/may not have related patients that are not being shown.",
        defaultMessage: 'We had trouble loading each "Related Persons" info. Please refresh the page to see all patient profiles.'
    },
    // messages.*
    // ==========
    calendarEventTitle: {
        id: 'messages.calendarEventTitle',
        description: "The title for the calendar event added to users' calendars",
        defaultMessage: 'Appointment with {provider_name}'
    },
    calendarEventDetails: {
        id: 'messages.calendarEventDetails',
        description: "The details for the calendar event added to users' calendars",
        defaultMessage: "Upcoming appointment with {provider_name}.  To contact {provider_name}'s office, please call {phone_number}."
    },
    // patient.*
    established: {
        id: 'patient.established',
        description: 'Established patient type',
        defaultMessage: 'established'
    },
    new: {
        id: 'patient.new',
        description: 'New patient type',
        defaultMessage: 'new'
    },
    existingPatientButtonText: {
        id: 'patientrel.existing.buttontext',
        description: 'Button text for "existing" patientRel button when querying availability for a single provider.',
        defaultMessage: 'Yes'
    },
    newPatientButtonText: {
        id: 'patientrel.new.buttontext',
        description: 'Button text for "new" patientRel button when querying availability for a single provider.',
        defaultMessage: 'No'
    },
    // step_title.*
    // ============
    appointmentPurposeTitle: {
        id: 'step_title.appointment_reason',
        description: 'Text for the appointment purpose step title',
        defaultMessage: 'What is the main reason for your visit?'
    },
    patientRelTitle: {
        id: 'step_title.existing_patient',
        description: 'Text for the existing patient step title',
        defaultMessage: 'Have you seen {display_name} before?'
    },
    apptBooked: {
        id: 'step_title.appointment_booked.complete',
        description: 'The header message at the top of the appointment summary page',
        defaultMessage: 'Appointment Successfully Booked for {firstName} {lastName}'
    },
    apptUnavailable: {
        id: 'step_title.appointment_unavailable',
        description: 'The header message at the top of the review and book appointment page when the booking fails due to appointment no longer being available',
        defaultMessage: 'Unfortunately, the appointment you selected is no longer available'
    },
    // aria.*
    // ======
    ariamapcontainer: {
        id: 'aria.label.mapcontainer',
        description: "Accessibility label identifying the map of the provider's offices",
        defaultMessage: "Map of the provider's office(s)"
    },
    ariaJumpToDateCalendarInput: {
        id: 'aria.label.jumpToDate.calendarInput',
        description: 'Accessibility label for jump to date calendar input',
        defaultMessage: 'Jump to a Date Calendar'
    },
    ariaJumpToDateCalendarButton: {
        id: 'aria.label.jumpToDate.calendarButton',
        description: 'Accessibility label for jump to date calendar button',
        defaultMessage: 'Jump to a Date'
    },
    ariaJumpToDateFilterCloseButton: {
        id: 'aria.label.jumpToDate.close',
        description: 'Accessibility label for jump to date filter close button',
        defaultMessage: 'Close Filter'
    },
    ariaJumpToDateFilterTimeOfDayButton: {
        id: 'aria.label.jumpToDate.filterByTimeOfDay',
        description: 'Accessibility label for jump to date filter by time of day button',
        defaultMessage: 'Filter by Time of Day'
    },
    ariaJumpToDateFilterDayOfWeekButton: {
        id: 'aria.label.jumpToDate.filterByDayOfWeek',
        description: 'Accessibility label for jump to date filter by day of week button',
        defaultMessage: 'Filter by Day of Week'
    },
    ariaJumpToDateInputDescription: {
        id: 'aria.label.jumpToDate.input.description',
        description: 'Accessibility for jump to date selected date input field',
        defaultMessage: "Enter a date on or after today's date to filter appointments for a specific date."
    },
    ariaProviderTimeSlotDescription: {
        id: 'aria.label.provider.timeSlot.description',
        description: 'Accessibility for provider time slot button description',
        defaultMessage: `Book appointment with {providerName} on {date} at {time}.`
    },
    ariaBackToSearchPageButton: {
        id: 'aria.label.backToSearchPage',
        description: 'Accessibility label for the button that returns to the search page',
        defaultMessage: `Close and go back to the search page`
    },
    ariaGoBackToPreviousStep: {
        id: 'aria.label.backToPreviousStep',
        description: 'Accessibility label for the button that goes back to the previous step',
        defaultMessage: `Go back to previous step`
    },
    ariaApptInfo: {
        id: 'aria.label.detailsButton',
        description: 'Accessibility label for the button that will take to details step',
        defaultMessage: 'Go back to details'
    },
    ariaApptTime: {
        id: 'aria.label.dateAndTimeButton',
        description: 'Accessibility label for the button that will take to Date & Time step',
        defaultMessage: 'Go back to date and time'
    },
    ariaPatientInfo: {
        id: 'aria.label.patientInfoButton',
        description: 'Accessibility label for the button that will take to patientInfo step',
        defaultMessage: 'Go back to registration'
    },
    ariaPrintConfirmation: {
        id: 'aria.label.printConfirmationButton',
        description: 'Accessibility label for button on appointment confirmation page that prints the appointment details',
        defaultMessage: 'Print confirmation'
    },
    ariaFilterByLocation: {
        id: 'aria.label.filterByLocation',
        description: 'Accessibility label for the filter by location button',
        defaultMessage: 'Filter by location'
    },
    ariaFilterByDayOfWeek: {
        id: 'aria.label.arialFilterByDayOfWeek',
        description: 'Accessibility label for filter by day of week button',
        defaultMessage: 'Filter by day of week'
    },
    // labels.*
    // =========
    availableLocationsLabel: {
        id: 'labels.available_locations',
        description: 'available locations map header',
        defaultMessage: 'Available locations'
    },
    printButtonText: {
        id: 'labels.printButtonText',
        description: 'Text for the button that lets users print their appointment details',
        defaultMessage: 'Print'
    },
    appointmentType: {
        id: 'labels.appointmentType',
        description: 'A label that renders: Appointment type',
        defaultMessage: 'Appointment type'
    },
    providerName: {
        id: 'labels.providerName',
        description: 'A label that renders: Provider name',
        defaultMessage: 'Provider name'
    },
    location: {
        id: 'labels.location',
        description: 'A label that renders: Location',
        defaultMessage: 'Location'
    },
    dateOfBirth: {
        id: 'labels.dateOfBirth',
        description: 'A label that renders: Date of birth',
        defaultMessage: 'Date of birth'
    },
    emailAddress: {
        id: 'labels.emailAddress',
        description: 'A label that renders: Email address',
        defaultMessage: 'Email address'
    },
    phoneNumber: {
        id: 'labels.phoneNumber',
        description: 'A label that renders: Phone number',
        defaultMessage: 'Phone number'
    },
    insurance: {
        id: 'labels.insurance',
        description: 'A label that renders: Insurance',
        defaultMessage: 'Insurance'
    },
    patientNotes: {
        id: 'labels.patientNotes',
        description: 'A label that renders: Patient notes',
        defaultMessage: 'Patient notes'
    },
    backToSearch: {
        id: 'labels.backToSearchResult',
        description: 'A label text for the Back to search results link',
        defaultMessage: 'Back to search results'
    },
    stepperApptInfo: {
        id: 'steps.existing_patient',
        description: 'The stepper label for the ApptInfo step',
        defaultMessage: 'Details'
    },
    stepperApptTime: {
        id: 'steps.provider_schedule',
        description: 'The stepper label for the ApptTime step',
        defaultMessage: 'Date & Time'
    },
    stepperPatientInfo: {
        id: 'steps.patient_information',
        description: 'The stepper label for the PatientInfo step',
        defaultMessage: 'Registration'
    },
    stepperReviewAppt: {
        id: 'steps.confirm_appointment',
        description: 'The stepper label for the ReviewAppt step',
        defaultMessage: 'Review and Book'
    },
    goBack: {
        id: 'labels.goBack-cancel-v2',
        description: 'Text for the Back button in the stepper that brings users to the previous step',
        defaultMessage: 'Back'
    },
    dayOfWeek: {
        id: 'labels.day_of_week',
        description: 'A label that renders: Day OF Week',
        defaultMessage: 'Day Of Week'
    },
    // appointment_confirm.*
    // ===================
    reviewAndBook: {
        id: 'step_title.confirm_appointment',
        description: 'The header message at the top of the review and book appointment page; lets users know they still have to press the button to book',
        defaultMessage: 'Is all your information correct?'
    },
    reviewAndBookInstructions: {
        id: 'appointment_confirm.instructions',
        description: "Short text to expand on the instructions given by the review and book appointment page's heading",
        defaultMessage: 'Check your details below and click the Book Appointment button to complete your booking.'
    },
    patientDetails: {
        id: 'appointment_confirm.patient_details',
        description: 'The heading above the patient details section of the review and book page',
        defaultMessage: 'Patient Details'
    },
    appointmentDate: {
        id: 'appointment_confirm.appointment_date',
        description: 'A label that renders: Appointment date',
        defaultMessage: 'Appointment date'
    },
    bookAppointment: {
        id: 'appointment_confirm.book_appointment',
        description: 'A label that renders: Book Appointment',
        defaultMessage: 'Book Appointment'
    },
    didBookAppointment: {
        id: 'appointment_confirm.did_book_appointment',
        description: 'A label that renders: Appointment Booked',
        defaultMessage: 'Appointment Booked'
    },
    appointmentId: {
        id: 'appointment_confirm.appointment_id',
        description: 'A label that indicates the booked appointment id',
        defaultMessage: 'Appointment ID: {appointmentId}'
    },
    // captcha.*
    // ===================
    interruptionapology: {
        id: 'captcha.interruption_apology',
        description: 'Captcha Apology for Interruption',
        defaultMessage: 'Sorry for the interruption!'
    },
    notrobot: {
        id: 'captcha.not_robot',
        description: 'Make sure customer is not a robot',
        defaultMessage: "We want to make sure you're not a robot."
    },
    cancel: {
        id: 'captcha.cancel',
        description: 'Text for captcha cancel button',
        defaultMessage: 'Cancel'
    },
    retry: {
        id: 'captcha.retry',
        description: 'Text for captcha to retry after server error',
        defaultMessage: 'Retry'
    },
    recaptchaFailed: {
        id: 'captcha.failed',
        description: 'Text when recaptcha validation has failed due to server error',
        defaultMessage: ' There was an error validating the recaptcha response. Please try again.'
    },
    // phoneNumberLink_title_attribute.*
    // ===================
    phoneNumberLinkTitle: {
        id: 'phoneNumberLink.title_attribute',
        description: 'Text for HTML title attribute for PhoneNumberLink',
        defaultMessage: 'Call {phone_number}'
    },
    // appointment_method.*
    // ===================
    appointmentPhoneTitle: {
        id: 'appointment_method.phone_title',
        description: 'Title when visit type is phone',
        defaultMessage: 'Phone Visit'
    },
    appointmentVideoTitle: {
        id: 'appointment_method.video_title',
        description: 'Title when visit type is video',
        defaultMessage: 'Video Visit'
    },
    appointmentInPersonTitle: {
        id: 'appointment_method.in_person_title',
        description: 'Title when visit type is In Person',
        defaultMessage: 'In Person'
    },
    appointmentPhoneContent: {
        id: 'appointment_method.phone_content',
        description: 'Text when visit type is phone',
        defaultMessage: 'Phone visits allow you to speak with medical providers from the comfort of your home via phone.'
    },
    appointmentVideoContent: {
        id: 'appointment_method.video_content',
        description: 'Text when visit type is video',
        defaultMessage: 'Video visits, also known as telehealth or virtual visits, allow you to meet with medical providers from the comfort of your home via smart phone, tablet, or computer.'
    },
    // demographics_form.*
    // ===================
    demographicsFormHeader: {
        id: 'demographics_form.header_title',
        description: 'Text for the header at the top of the demographics form',
        defaultMessage: 'Patient Demographics'
    },
    demographicsFormNameLabel: {
        id: 'demographics_form.name_label',
        description: 'Text for the label of the form input for demographic name',
        defaultMessage: 'Name'
    },
    demographicsFormDobLabel: {
        id: 'demographics_form.dob_label',
        description: 'Text for the label of the form input for demographic date of birth',
        defaultMessage: 'Date of Birth'
    },
    demographicsFormGenderLabel: {
        id: 'demographics_form.gender_label',
        description: 'Text for the label of the form input for demographic gender',
        defaultMessage: 'Gender'
    },
    demographicsFormAddressLabel: {
        id: 'demographics_form.address_label',
        description: 'Text for the label of the form input for demographic address',
        defaultMessage: 'Address'
    },
    // third_party.*
    // ===================
    mychartLoginHeader: {
        id: 'third_party.mychart.login_header',
        description: 'Text for the MyChart login banner header',
        defaultMessage: 'Connect with MyChart'
    },
    mychartLoginDescription: {
        id: 'third_party.mychart.login_description',
        description: 'Descriptive text for the MyChart login banner content',
        defaultMessage: 'Autofill your information by logging into your MyChart account.'
    },
    mychartLoginAction: {
        id: 'third_party.mychart.login_action',
        description: 'Text for the MyChart login banner action button',
        defaultMessage: 'Log in to MyChart \u2197'
    },
    mychartLoginSeparator: {
        id: 'third_party.mychart.login_separator',
        description: 'Text for the MyChart login banner that is displayed within a separator',
        defaultMessage: 'OR'
    },
    mychartLogoutDescription: {
        id: 'third_party.mychart.logout_description',
        description: 'Descriptive text for the MyChart logout banner content',
        defaultMessage: 'Your MyChart account is connected. Please check the fields below to confirm your information.'
    },
    mychartLogoutAction: {
        id: 'third_party.mychart.logout_action',
        description: 'Text for the MyChart logout banner action button',
        defaultMessage: 'Unlink MyChart'
    },
    mychartLoginErrorDescription: {
        id: 'third_party.mychart.login_general_error_description',
        description: 'Descriptive text for the MyChart login banner content following a general error',
        defaultMessage: 'We had trouble processing your request. Please try again.'
    },
    mychartLoginErrorAction: {
        id: 'third_party.mychart.login_general_error_action',
        description: 'Text for the MyChart login banner action button following a general error',
        defaultMessage: 'Retry MyChart Login'
    },
    // patient_demographics.*
    // ======================
    proxyBookingControlsHeader: {
        id: 'patient_demographics.proxy_booking_controls_header',
        description: 'Header for the proxy booking select box',
        defaultMessage: 'Who is this Appointment for?'
    },
    proxyBookingSomeoneElse: {
        id: 'patient_demographics.someone_else',
        description: "Text for the 'Someone Else' option in the proxy booking select box",
        defaultMessage: 'Someone else'
    },
    apptTimeFilterBy: {
        id: 'appointment_panel.filter_by',
        description: 'Text for the filter label in appt time step',
        defaultMessage: 'Filter By'
    },
    apptTimeFilterStartDate: {
        id: 'appointment_panel.start_date',
        description: 'Label for the start date filter',
        defaultMessage: 'Start Date'
    },
    apptTimeFilterDayOfWeek: {
        id: 'appointment_panel.day_of_week',
        description: 'Text for the filter button day of week',
        defaultMessage: 'Day of Week'
    },
    apptTimeFilterTimeOfDay: {
        id: 'appointment_panel.time_of_day',
        description: 'Text for the filter button time of day',
        defaultMessage: 'Time of Day'
    },
    apptTimeFilterCloseBtn: {
        id: 'appointment_panel.btn_close',
        description: 'Text for the filter popover btn close paper',
        defaultMessage: 'Close'
    },
    apptTimeCalendarPlaceholder: {
        id: 'appointment_panel.calendar_placeholder',
        description: 'Text for calendar placeholder',
        defaultMessage: 'Jump to a Date'
    },
    apptTimeFilterAppointments: {
        id: 'appointment_panel.filter_appointments',
        description: 'Text for header of filter appointments section',
        defaultMessage: 'Filters ({filterCount})'
    },
    apptTimeFilterAvailableDates: {
        id: 'appointment_panel.available_dates',
        description: 'Text for header of available dates filter section',
        defaultMessage: 'Available Dates and Times'
    },
    apptTimeFilterApplyFilters: {
        id: 'appointment_panel.apply_filters',
        description: 'Text for filter apply button',
        defaultMessage: 'Apply filters'
    },
    apptTimeFilterClearFilters: {
        id: 'appointment_panel.clear_filters',
        description: 'Text for filter clear button',
        defaultMessage: 'Clear filters'
    },
    // Date Dropdown
    dateFilterLabel: {
        id: 'date_filter.label',
        description: 'Label for the date filter',
        defaultMessage: 'Date'
    },
    // Day of Week Dropdown
    anyDayOfWeek: {
        id: 'dayOfWeek.any_day',
        description: 'display value for day of week when all the days are selected',
        defaultMessage: 'Any Day'
    },
    // time filter labels
    'timeOfDay.all': {
        id: 'days.all',
        description: 'Label for ALL time filter',
        defaultMessage: 'ALL'
    },
    'timeOfDay.am': {
        id: 'days.am',
        description: 'Label for AM time filter',
        defaultMessage: 'AM'
    },
    'timeOfDay.pm': {
        id: 'days.pm',
        description: 'Label for PM time filter',
        defaultMessage: 'PM'
    },
    'timeOfDay.anytime': {
        id: 'days.anytime',
        description: 'Label for Anytime time filter',
        defaultMessage: 'Anytime'
    },
    'timeOfDay.label': {
        id: 'days.label',
        description: 'Label for time of day filter',
        defaultMessage: 'Time of Day'
    },
    ariaFilterByTimeOfDay: {
        id: 'aria.label.filterByTimeOfDay',
        description: 'Accessibility label for the filter by time of day button',
        defaultMessage: 'Filter by time of day'
    },
    // alt_providers.*
    // ======================
    altProvidersHeader: {
        id: 'alt_providers.header_text',
        description: 'Header text for the Alternative Providers section',
        defaultMessage: 'Similar Providers'
    },
    careTeamsProvidersHeader: {
        id: 'care_teams_providers.header_text',
        description: 'Header text for the Care Teams Providers section',
        defaultMessage: 'Care Team Providers'
    },
    suggestedProvidersText: {
        id: 'alt_providers.suggested_providers_text',
        description: 'Text for the suggested providers section',
        defaultMessage: 'We found other providers that might work for you:'
    },
    // confirmation page
    // for direct-book-widget-v2
    appointmentConfirmedTitle: {
        id: 'confirmation_page.appointment_confirmed.confirmation_title',
        description: 'Booking Confirmed',
        defaultMessage: 'Appointment Successfully Booked'
    },
    // for direct-book-widget-v2
    appointmentConfirmed: {
        id: 'confirmation_page.appointment_confirmed.confirmation_message',
        description: 'You should receive an email confirmation soon. Your provider may call before the appointment to confirm additional details.',
        defaultMessage: 'You should receive an email confirmation soon. Your provider may call before the appointment to confirm additional details.'
    },
    // JoinWaitlist
    joinWaitlistHeader: {
        id: 'join_waitlist.title',
        description: 'Header for the Join Waitlist component',
        defaultMessage: 'Join Waitlist'
    },
    joinWaitlistDescription: {
        id: 'join_waitlist.description',
        description: 'Description for the Join Waitlist component',
        defaultMessage: 'Earlier options may open up before your scheduled appointment. If you provide a mobile number we’ll notify you about openings via SMS.'
    },
    joinWaitlistOptInLabel: {
        id: 'join_waitlist.opt_in_label',
        description: 'Label for the opt-in checkbox in the Join Waitlist component',
        defaultMessage: 'Add me to a waitlist for earlier appointments'
    },
    joinWaitlistPhoneLabel: {
        id: 'join_waitlist.phone_label',
        description: 'Label for the phone number input in the Join Waitlist component',
        defaultMessage: 'Mobile Number'
    },
    invalidPhoneNumberValidationMessage: {
        id: 'join_waitlist.phone_number_validation_message',
        description: 'Validation message for the phone number input in the Join Waitlist component',
        defaultMessage: 'Please enter a valid phone number to join waitlist'
    },
    phoneNumberIsRequiredValidationMessage: {
        id: 'join_waitlist.phone_number_is_required_validation_message',
        description: 'Validation message for the phone number input in the Join Waitlist component',
        defaultMessage: 'Phone number is required to join waitlist'
    },
    phoneNumberInformationMessage: {
        id: 'join_waitlist.phone_number.information_message',
        description: 'Information message for the phone number input in the Join Waitlist component',
        defaultMessage: `By providing your mobile number, you consent to receive appointment-related text messages from {providerName}. Messages may include appointment reminders and notifications about earlier available appointments. Message and data rates may apply. Reply STOP to opt out. For help, reply HELP.`
    },
    ariaJoinWaitlistPhoneInputDescription: {
        id: 'aria.label.join_waitlist.phone_number_input_description',
        description: 'Accessibility label for the phone input in Join Waitlist',
        defaultMessage: 'Please enter a 10 digit US phone number. If entry is a valid US phone the number will be formatted automatically.'
    }
});
//# sourceMappingURL=messages.js.map